/*
 * @Author: JamesWong
 * @Description: 账户配置中文包
 * @Date: 2018-11-30 10:09:38
 * @Last Modified by: JamesWong
 * @Last Modified time: 2018-11-30 15:02:12
 */
export default {
  basicInformation: '基本資料',
  enterpriseNumber: '企業編號',
  enterpriseName: '企業名稱'
}


// WEBPACK FOOTER //
// ./src/i18n/zh-hant/account.js